import { render, staticRenderFns } from "./article.vue?vue&type=template&id=4c5f8930&scoped=true"
import script from "./article.vue?vue&type=script&lang=ts"
export * from "./article.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f8930",
  null
  
)

export default component.exports